<div class="container my-5 mt-5">
    <div class="card shadow-sm">
      <div class="card-body">
        <h1 class="mb-4 text-primary">🛡️ Política de Privacidad - Libre Salud</h1>
        <p><strong>Última actualización:</strong> 17 de junio de 2025</p>

        <p>
          Libre Salud es propiedad de <strong>Proyectar Calidad S.A.</strong>, con CUIT 33-71445950-9, con domicilio en Guayra 2061. Piso: 3. Dpto: B. Ciudad Autónoma de Buenos Aires, Argentina.<br>
          Es una aplicación desarrollada por <strong>Drimfix S.A.</strong>,
          comprometida con la privacidad y protección de los datos personales de sus usuarios.
        </p>

        <h2 class="mt-4">📸 Permisos solicitados</h2>
        <ul>
          <li><strong>Cámara:</strong> para que el usuario pueda subir foto de perfil, DNI, matrícula o recetas médicas.</li>
          <li><strong>Ubicación (GPS):</strong> para facilitar el ingreso de domicilio o ubicación rápida en turnos o pedidos.</li>
          <li><strong>Notificaciones:</strong> para avisos de pedidos, turnos y novedades.</li>
        </ul>

        <h2 class="mt-4">👤 Datos personales que recopilamos</h2>
        <p>El usuario puede ingresar voluntariamente los siguientes datos:</p>
        <ul>
          <li>Nombre y apellido</li>
          <li>Correo electrónico</li>
          <li>Tipo y número de documento</li>
          <li>Número de matrícula (si aplica)</li>
          <li>Datos del comercio (si aplica)</li>
        </ul>
        <p>Estos datos son usados exclusivamente para el funcionamiento de la app.</p>

        <h2 class="mt-4">🧩 Servicios de terceros</h2>
        <p>Utilizamos <strong>Firebase (Google)</strong> para:</p>
        <ul>
          <li>Login de usuarios</li>
          <li>Envío de notificaciones</li>
        </ul>
        <p>Solo se guarda el ID de usuario y el email.</p>

        <h2 class="mt-4">🔐 Seguridad de los datos</h2>
        <p>
          Los datos se almacenan de forma segura y no se comparten con terceros ajenos al funcionamiento de la app.
        </p>

        <h2 class="mt-4">🗑️ Eliminación de datos</h2>
        <p>
          El usuario puede solicitar la eliminación de sus datos personales escribiendo a:
        </p>
        <p><strong>Email:</strong> <a href="mailto:libresalud@drimfix.com"> libresalud&#64;drimfix.com</a></p>

        <h2 class="mt-4">📞 Contacto</h2>
        <p>
          Para consultas sobre esta política escribinos a:
        </p>
        <p><strong>Email:</strong> <a href="mailto:libresalud@drimfix.com"> libresalud&#64;drimfix.com</a></p>

        <h2 class="mt-4">📝 Cambios en esta política</h2>
        <p>
          Nos reservamos el derecho a modificar esta política. Te notificaremos en caso de cambios importantes.
        </p>
      </div>
    </div>
  </div>